import {XTextButton} from "@cdx/common";
export default XTextButton;
